import React from "react";
import styled from "styled-components";
import { colors } from "../../../theme";
import RenderServicingContact from "./RenderServicingContact";

function ServicingManager({ data }) {
  const contactDetail = (contactDetails, index) => {
    return (
      <div>
        <OuterDiv>
          <>
            {data.map((value, index) => {
              const contact_length = contactDetails.length;
              return (
                <>
                  <RenderServicingContact
                    claim={value}
                    index={index}
                    contact_length={contact_length}
                  />
                </>
              );
            })}
          </>
        </OuterDiv>
      </div>
    );
  };
  return <ParentDiv>{contactDetail(data, 1)}</ParentDiv>;
}

export default ServicingManager;

const OuterDiv = styled.div`
  background-color: ${colors.newCardBgColor};
  padding: 24px;
  position: relative;
  display: flex;
  border-radius: 10px;
`;

const LevelTag = styled.div`
  width: 50px;
  height: 20px;
  background-color: #65179a;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  top: 0px;
`;

const ParentDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  top: 0;
`;
